import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import MaterialTable from 'material-table';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import { CircularProgress } from '@material-ui/core';
import withAlert from '../../hoc/withAlert';
import DetailPanel from './components/DetailPanel';

import {
  loadMeal,
  addMeal,
  delMeal,
  changeMeal,
  getMealSelector
} from '../../store/meal';
// import * as appActions from '../../../../store/app/actions';

import { initPage, getPageReadyByPageSelector } from '../../store/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  displayNone: { display: 'none' }
}));

const Dishes = props => {
  const classes = useStyles();
  // Заберем из HOC нужные методы для показа алерта
  const { setSnackMessage, setSnackType, setOpenSnack } = props;
  const mealData = useSelector(getMealSelector);
  const dispatch = useDispatch();

  const tableRef = useRef();

  const pageReady = useSelector(
    getPageReadyByPageSelector(props.location.pathname)
  );

  const tableColumns = [
    { title: 'ID', field: 'id', editable: 'never', defaultSort: 'desc' },
    { title: 'Название', field: 'name' },
    { title: 'Цена', field: 'price', initialEditValue: 0 },

    { title: 'Цена сотруд', field: 'priceStaff', initialEditValue: 0 },
    { title: 'Спеццена', field: 'priceHelpers', initialEditValue: 0 },
    { title: 'Цена дети до 5', field: 'priceKids5', initialEditValue: 0 },
    { title: 'Цена дети до 12', field: 'priceKids12', initialEditValue: 0 },

    { title: 'Баллы', field: 'points', initialEditValue: 1 },

    {
      title: 'Тип',
      field: 'mealTypeId',
      lookup: { 1: 'Raw', 2: 'Veg' },
      initialEditValue: 2
    },
    {
      title: 'Комбо',
      field: 'isCombo',
      lookup: { 2: 'Нет', 1: 'Да' },
      initialEditValue: 2
    }
  ];

  const [state, setState] = useState({});

  const handleToggle = rowId => {
    tableRef.current.onToggleDetailPanel([rowId], rowData => {
      return <DetailPanel rowData={rowData} onToggle={handleToggle} />;
    });
  };

  const detailPanel = [
    rowData => ({
      disabled: parseInt(rowData.isCombo) === 2,
      icon: () => (
        <UnfoldMoreIcon
          className={parseInt(rowData.isCombo) === 2 ? classes.displayNone : ''}
        />
      ),
      openIcon: UnfoldLessIcon,
      render: () => {
        return <DetailPanel rowData={rowData} onToggle={handleToggle} />;
      }
    })
  ];

  useEffect(() => {
    const getData = async () => {
      // await dispatch(loadMeal());
      await initPage(props.location.pathname, dispatch);
    };
    getData();
  }, [dispatch]);

  useEffect(() => {
    if (mealData) {
      setState({ columns: tableColumns, data: _.cloneDeep(mealData) });
    }
  }, [mealData]);

  return (
    <React.Fragment>
      {pageReady === false && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}
      <div className={classes.root}>
        <div className={classes.content}>
          {pageReady && (
            <MaterialTable
              tableRef={tableRef}
              title="Список блюд"
              columns={state.columns}
              data={state.data}
              options={{
                actionsColumnIndex: -1,
                pageSize: 100,
                addRowPosition: 'first',
                rowStyle: rowData => ({
                  backgroundColor: rowData.isCombo !== 2 ? '#ecf1fa' : '#FFF'
                })
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: '{from}-{to} из {count}',
                  labelRowsSelect: 'строк',
                  labelRowsPerPage: 'Строк на странице',
                  firstAriaLabel: 'Первая',
                  firstTooltip: 'Первая',
                  previousAriaLabel: 'Назад',
                  previousTooltip: 'Назад',
                  nextAriaLabel: 'Вперед',
                  nextTooltip: 'Вперед',
                  lastAriaLabel: 'Последняя',
                  lastTooltip: 'Последняя'
                },
                toolbar: {
                  nRowsSelected: '{0} строк выбранно',
                  searchTooltip: 'Найти',
                  searchPlaceholder: 'Найти'
                },
                header: {
                  actions: 'Действия'
                },
                body: {
                  addTooltip: 'Добавить',
                  editTooltip: 'Редактировать',
                  deleteTooltip: 'Удалить',
                  emptyDataSourceMessage: 'По запросу ничего не найдено',
                  filterRow: {
                    filterTooltip: 'Фильтер'
                  },
                  editRow: {
                    deleteText: 'Вы уверены, что хотите удалить блюдо?',
                    cancelTooltip: 'Отменить',
                    saveTooltip: 'Выполнить'
                  }
                }
              }}
              detailPanel={detailPanel}
              onRowClick={(event, rowData, togglePanel) =>
                parseInt(rowData.isCombo) === 2 ? () => {} : togglePanel()
              }
              // onRowClick={(event, rowData, togglePanel) => togglePanel() }
              editable={{
                onRowAdd: newData =>
                  new Promise(resolve => {
                    setTimeout(async () => {
                      resolve();
                      await dispatch(addMeal(newData));
                    }, 600);
                  }),
                onRowUpdate: (newData, oldData) =>
                  new Promise(resolve => {
                    setTimeout(async () => {
                      resolve();
                      if (oldData) {
                        await dispatch(changeMeal(newData));
                      }
                    }, 600);
                  }),
                onRowDelete: oldData =>
                  new Promise(resolve => {
                    setTimeout(async () => {
                      resolve();
                      await dispatch(delMeal(oldData.id));
                    }, 600);
                  })
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withAlert(Dishes);
